import { render } from "./Closure.vue?vue&type=template&id=3ee535ab&scoped=true"
import script from "./Closure.vue?vue&type=script&lang=js"
export * from "./Closure.vue?vue&type=script&lang=js"

import "./Closure.vue?vue&type=style&index=0&id=3ee535ab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ee535ab"

export default script